import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render winning limits section for FAQ Page
 */
const WinningLimitsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="winning-limits-section-component"
    >
      <AccordionV2
        testId="winning-limits"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Are there limits to the number of times a company/individual can win an award?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 mt-2 px-6 py-4 pb-0">
          <p>
            For the Best Annual Report Award, Best Investor Relations Award,
            Best Risk Management Award and Best Managed Board Award, the Gold
            winners will step down for two years (in the respective categories),
            after which they will be reconsidered for the award.
          </p>

          <p>
            For Best CEO and Best CFO, the winners will not be eligible for
            consideration if they remain in the same company.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default WinningLimitsSection;
